import {
  CV_HIDE_MENU_AVATAR,
  CV_HIDE_MENU_AVATAR_MOBILE,
  CV_SHOW_MENU_AVATAR,
  CV_SHOW_MENU_AVATAR_MOBILE,
} from './action-creator';

export const showMenuAvatar = () => dispatch => {
  dispatch({
    type: CV_SHOW_MENU_AVATAR,
  });
};
export const hideMenuAvatar = () => dispatch => {
  dispatch({
    type: CV_HIDE_MENU_AVATAR,
  });
};

export const showMenuAvatarMobile = () => dispatch => {
  dispatch({
    type: CV_SHOW_MENU_AVATAR_MOBILE,
  });
};
export const hideMenuAvatarMobile = () => dispatch => {
  dispatch({
    type: CV_HIDE_MENU_AVATAR_MOBILE,
  });
};
